export enum QUERY_KEYS {
  DOCUMENT_THEMES = 'DOCUMENT_THEMES',
}

export default QUERY_KEYS
